<template>
  <div>
    <v-dialog
      v-model="dialogItemQuestTracking"
      persistent
      max-width="600px"
      class="container1"
      scrollable
      :key="keyComponent"
    >
      <v-card :height="innerHeight" class="overflow-auto">
        <div class="d-flex justify-center pa-2" style="position: relative">
          <div style="max-height: 240px">
            <img
              :src="dataItem.image_url || dataItem.image_path"
              style="
                max-width: 100%;
                max-height: 240px;
                width: auto;
                height: auto;
                border-radius: 10px;
                object-fit: contain;
                display: block;
                margin: 0 auto;
              "
              @error="onImageError($event, null, '')"
            />
          </div>

          <v-btn
            fab
            x-small
            style="z-index: 9999; position: absolute; top: 8px; right: 8px"
            class="ma-1 close-button"
            @click="$emit('close')"
            ><v-icon small :color="site.color">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <p class="text-subtitle-1 mb-0" v-snip="{ lines: 2 }">
            {{ dataItem.title }}
          </p></v-card-title
        >

        <v-divider style="opacity: 1; color: black" class="ma-3"></v-divider>

        <v-card-text>
          <v-list-item
            class="pa-0"
            v-if="['normal', 'location'].includes(dataItem.mode)"
          >
            <v-list-item-avatar size="30" class="ml-1 mr-6">
              <PointSymbol
                v-if="
                  Array.isArray(dataItem.point) && dataItem.point.length > 0
                "
                :type="dataItem.point[0].point_type_type"
                :symbol="dataItem.point[0].point_type_symbol"
                :color="dataItem.point[0].point_type_color"
                :is_display="true"
                :outlined_box="false"
                :size="30"
              />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-size: 10px">{{
                $t("collectCoin")
              }}</v-list-item-title>
              <v-list-item-subtitle>
                <div
                  v-if="
                    Array.isArray(dataItem.point) && dataItem.point.length > 0
                  "
                  class="d-flex"
                >
                  {{ dataItem.point[0].point | commaPoint }}
                  {{ dataItem.point[0].point_type_name }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="pa-0" v-else>
            <v-list-item-avatar size="30" class="ml-1 mr-6">
              <v-img src="@/assets/images/price.png"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-size: 10px">{{
                $t("valueItem")
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                dataItem.raw_value | commaPoint
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <p class="text-subtitle-2 mb-0 font-weight-bold">
            {{ $t("detail") }}
          </p>

          <div
            class="ql-editor"
            v-html="formatHtmlDetail(dataItem.description)"
            style="margin-top: 16px; height: fit-content"
          ></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import PointSymbol from "../point/point-symbol.vue";
import { formatHtmlDetailDefault } from "../../config/general-function.js";

export default {
  components: { PointSymbol },
  props: ["item", "dialogItemQuestTracking", "keyComponent", "site"],
  data() {
    return {
      dataItem: {},
    };
  },

  watch: {
    item: {
      handler() {
        this.dataItem = this.item;
        console.log("dataItem :>> ", this.dataItem);
      },
      deep: true,
    },
  },

  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 100;
    },
    itemImage() {
      return this.dataItem.image_url;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
